import "./Buttons.scss";

const Buttons = ({buttonText, onClick, type="submit"})=> {
    return (
        <button
        type={type}
        className="btn"
        onClick={onClick}
        >
            {buttonText}
        </button>
    )
}
export default Buttons;